import React, {Fragment} from 'react';
import AppHeader from '../components/global/AppHeader';
import Hero from '../components/hero/HomeHero';
import StatSlider from '../components/StatSlider';
import ProjectVideo from '../components/ProjectVideo';
import Testimonials from '../components/testimonials/Index';
import Team from '../components/team/Index';
import Outro from '../components/Outro';
import PressLinks from '../components/PressLinks';
import ProgressBar from "react-scroll-progress-bar"; 

class Index extends React.Component {
	componentDidMount() {
		document.addEventListener('scroll', this.toggleBodyClass);
		this.toggleBodyClass();
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.toggleBodyClass);
	}

	toggleBodyClass = () => {
		if (window.scrollY >= 2000) {
			document.body.classList.add('is-bottom');
		} else {
			document.body.classList.remove('is-bottom');
		}

		// const windowWidth = window.innerWidth;
		// const breakpoint = 640;

		// if (windowWidth > breakpoint) {
		if (window.scrollY >= 3500 && window.scrollY <= 5300) {
			document.body.classList.add('is-dark');
		} else {
			document.body.classList.remove('is-dark');
		}
		// }
	};

	handleScrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	render() {
		return (
			<Fragment>
				<AppHeader />
                <div className="progress-bar">
                    <ProgressBar bgcolor="#403d3d" />
                </div>
				<main id="main" role="main">
					<Hero />
					<StatSlider />
					<ProjectVideo />
					<Testimonials />
					<Team />
					<Outro />
					<PressLinks />
				</main>
                <div className="back-to-top" onClick={this.handleScrollToTop}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="40"
                        height="40"
                        fill="#3d3d3d"
                        viewBox="0 0 50 50">
                        <path d="M4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9c0-2.76-2.24-5-5-5H9C6.24,4,4,6.24,4,9z M37.71,29.29 C37.9,29.49,38,29.74,38,30s-0.1,0.51-0.29,0.71c-0.39,0.39-1.03,0.39-1.42,0L25,19.41l-11.29,11.3c-0.39,0.39-1.03,0.39-1.42,0 c-0.39-0.39-0.39-1.03,0-1.42L25,16.59L37.71,29.29z"></path>
                    </svg>
                </div>
			</Fragment>
		);
	}
}

// const Index = () => {

// };

export default Index;
